// extracted by mini-css-extract-plugin
export default {"header_container":"verityPage_header_container__T8m5J","verity_main":"verityPage_verity_main__OG1iw","right_content":"verityPage_right_content__DFlWL"};